var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFromToIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 5,
    viewBox: "0 0 14 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37632 4.81046C8.77841 4.81046 8.23485 4.68363 7.74565 4.42997C7.27457 4.17631 6.83067 3.88642 6.41394 3.56028C6.01534 3.23415 5.61673 2.94425 5.21812 2.69059C4.83764 2.43694 4.42997 2.31011 3.99513 2.31011C3.56028 2.31011 3.15262 2.46411 2.77213 2.77213C2.39164 3.06203 2.03833 3.51499 1.7122 4.13102L0 2.90802C0.616029 1.87526 1.27735 1.13241 1.98397 0.679444C2.6906 0.226482 3.38816 0 4.07666 0C4.69269 0 5.23624 0.135889 5.70732 0.407666C6.1784 0.661325 6.61325 0.95122 7.01185 1.27735C7.42858 1.58537 7.82719 1.8662 8.20767 2.11986C8.60628 2.37352 9.01395 2.50035 9.43067 2.50035C9.86552 2.50035 10.2732 2.3554 10.6537 2.06551C11.0342 1.77561 11.3965 1.31359 11.7408 0.679444L13.4258 1.9568C12.8098 2.97143 12.1484 3.70523 11.4418 4.15819C10.7533 4.59304 10.0648 4.81046 9.37632 4.81046Z",
    fill: "#2C3A4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFromToIcon);
export default __webpack_public_path__ + "static/media/from-to-icon.e09d90e5c288893050cf3c48145c5e2a.svg";
export { ForwardRef as ReactComponent };